import React, { useEffect, useState, Component } from "react";
import { socket } from "../../../socket";
import bufferToString, {
    atob,
    btoa,
    toUnicode,
} from "../../../cryptographic/crypto";
import { subscriber, messageService } from "./subsPubs";

export class Connection {
    constructor() {
        // if(Connection._instance){
        //   throw new Error("Singleton classes can't be instantiated more than once.")
        // }
        // Connection._instance = this;
        this.socket = socket;
        // console.log("i am getting called always>>>>>>>>", this.socket);
        this.recurring = true;
        this.execute = false;
    }
    SocketContext1() { }

    eventsCall() {
        // this.execute = false;
        var response = {};

        if (socket) {
            socket.on("*", (event, data) => {
                // console.log("typeof ", typeof event);
                // console.log("typeof 1 ", event);
                if (typeof event === "string") {
                    if (event.indexOf("socket.io-file::") === 0) {
                    }
                } else {
                    event = bufferToString(event);
                    // console.log("events")
                    var message = atob(event);
                    if (message.length > 0) {
                        // console.log("events list", message)
                        console.log(message, "init message")
                        if (message.length > 1) {
                            if (message[0] == "init-message") {
                                response["init-message"] = message;
                                // console.log("print the data init-message", response["init-message"])
                            } else if (message[0] == "user-send") {
                                response["user-send"] = message;
                                // console.log("print the data user-send", response["user-send"])
                            } else if (message[0] == "agent-typeing") {
                                response["agent-typeing"] = message;

                                // console.log("print the data agent-typeing", response["agent-typeing"])
                            } else if (message[0] == "thread_change") {
                                response["thread_change"] = message;
                                // if(message[1].data.length == 1 && this.recurring){
                                //   this.something();
                                //  
                                // } else {
                                // }
                                this.execute = true;
                                this.socket.emit(btoa(["conversation-counts", { get: true }]));
                                // console.log("print the data thread_change", response["thread_change"])
                            } else if (message[0] == "conversation-counts") {
                                response["conversation-counts"] = message;
                                // console.log("print the data conversation-counts", response["conversation-counts"])
                            } else if (message[0] == "notification-ring") {
                                response["notification-ring"] = message;
                                // console.log("print the data notification-ring", response["notification-ring"])
                            } else if (message[0] == "screenShareRequest") {
                                response["screenShareRequest"] = message;
                                // console.log("print the data screenShareRequest", response["screenShareRequest"])
                            } else if (message[0] == "waitingForAccept") {
                                response["waitingForAccept"] = message;
                                // console.log("print the data waitingForAccept", response["waitingForAccept"])
                            } else if (message[0] == "screenKeys") {
                                response["screenKeys"] = message;
                                // console.log("print the data screenKeys", response["screenKeys"])
                            } else if (message[0] == "declineScreen") {
                                response["declineScreen"] = message;
                                // console.log("print the data declineScreen", response["declineScreen"])
                            } else if (message[0] == "user-message") {
                                // this.socket.emit(btoa(["open-chat", { conversation_id: localStorage.getItem('convoId'), option: localStorage.getItem('screen') }]));
                                response["user-message"] = message;
                                // console.log("print the data user-message", response["user-message"])
                                // this.socket.emit(btoa(["conversation-counts", { get: true }]));
                            } else if (message[0] == "messageChange") {
                                response["messageChange"] = message;
                                // console.log("print the data messageChange", response["messageChange"])
                                // this.socket.emit(btoa(["conversation-counts", { get: true }]));
                            } else if (message[0] == "customer-info") {
                                response["customer-info"] = message;
                                // console.log("print the data customer-info", response["customer-info"])
                            } else if (message[0] == "take-chat") {
                                response["take-chat"] = message;
                                this.socket.emit(btoa(["conversation-counts", { get: true }]));
                                // console.log("print the data take-chat", response["take-chat"])
                            } else if (message[0] == "agent-message") {
                                //  var sendData = {option:toUnicode(localStorage.getItem('screen')),page:(1),lastconvo_id:0};
                                //  return this.socket.emit(btoa(["open-chat", { conversation_id: localStorage.getItem('convoId'), option: localStorage.getItem('screen') }]));
                                response["agent-message"] = message;
                                // socket.emit(btoa(["conversation-counts", { get: true }]));
                                // console.log("print the data agent-message", response["agent-message"])
                            } else if (message[0] == "load_more_chat") {
                                response["load_more_chat"] = message;
                                // console.log("print the data load_more_chat", response["load_more_chat"])
                            } else if (message[0] == "user-typeing") {
                                response["user-typeing"] = message;
                                // console.log("print the data user-typeing", response["user-typeing"])
                            } else if (message[0] == "take-chat-fail") {
                                response["take-chat-fail"] = message;
                                // console.log("print the data take-chat-fail", response["take-chat-fail"])
                            } else if (message[0] == "take-chat-success") {
                                response["take-chat-success"] = message;
                                // console.log("print the data take-chat-success", response["take-chat-success"])
                            } else if (message[0] == "option") {
                                response["option"] = message;
                                // console.log("print the data option", response["option"])
                            } else if (message[0] == "transfer") {
                                response["transfer"] = message;
                                this.socket.emit(btoa(["conversation-counts", { get: true }]));
                                // console.log("print the data transfer", response["transfer"])
                            } else if (message[0] == "close-chat") {
                                response["close-chat"] = message;
                                this.socket.emit(btoa(["conversation-counts", { get: true }]));
                                // console.log("print the data close-chat", response["close-chat"])
                            } else if (message[0] == "chat-transfer") {
                                response["chat-transfer"] = message;
                                // console.log("print the data chat-transfer", response["chat-transfer"])
                            } else if (message[0] == "assign-chat") {
                                response["assign-chat"] = message;
                                this.socket.emit(btoa(["conversation-counts", { get: true }]));
                                // console.log("print the data assign-chat", response["assign-chat"])
                            } else if (message[0] == "update-user-info") {
                                response["update-user-info"] = message;
                                // console.log("print the data update-user-info", response["update-user-info"])
                            } else if (message[0] == "delete-user-info") {
                                response["delete-user-info"] = message;
                                // console.log("print the data delete-user-info", response["delete-user-info"])
                            } else if (message[0] == "request-form") {
                                // if(message[2]==true){
                                //     window.chat_talkk.genrateForm(event[1]);
                                // }else{
                                //     window.chat_talkk.genrateFormFail();
                                // }
                                response["request-form"] = message;
                                // console.log("print the data request-form", response["request-form"])
                            } else if (message[0] == "postForm") {
                                response["postForm"] = message;
                                // console.log("print the data", response["postForm"])
                            } else if (message[0] == "auth_success") {
                                response["auth_success"] = message;
                                // console.log("print the data", response["postForm"])
                            } else if (message[0] == "saveReactionResult") {
                                response["saveReactionResult"] = message;
                                console.log("saveReactionResult", response["saveReactionResult"])
                            }
                        }
                    }
                    // let a = 1;
                    if (Object.keys(response).length > 0) {
                        subscriber.next(response);
                        response = {};
                        // subscriber.next()
                        this.execute = false;
                        return;
                    } else {
                        return;
                    }
                }
            });

        } else {
            return;
        }
    }
}
